var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icVideoHS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-706.000000, -2385.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(670.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "on-the-ground-video",
    transform: "translate(27.000000, 2202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-gallery",
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.54938602,11.563401 C2.54938602,13.1667272 3.86968748,14.4870286 5.47265315,14.4866681 L12.5652174,14.4866681 L12.5652174,15.5394481 C12.5652174,16.3470601 11.9025429,17 11.0956519,17 L1.45730707,17 C0.650055578,17 -1.54543045e-13,16.3470601 -1.54543045e-13,15.5394481 L-1.54543045e-13,5.90146375 C-1.54543045e-13,5.09493334 0.650055578,4.43478261 1.45730707,4.43478261 L2.54938602,4.43478261 L2.54938602,11.563401 Z M15.5394481,7.28306304e-14 C16.3459785,7.28306304e-14 17,0.653300448 17,1.46091248 L17,11.0988968 C17,11.9068694 16.3459785,12.5652174 15.5394481,12.5652174 L5.90074266,12.5652174 C5.09421226,12.5652174 4.43478261,11.9068694 4.43478261,11.0988968 L4.43478261,1.46055194 C4.43478261,0.653660989 5.09385171,7.28306304e-14 5.90074266,7.28306304e-14 L15.5394481,7.28306304e-14 Z M10.120762,9.54611376 L13.2654261,7.01156341 C13.6330254,6.71549879 13.6330254,6.23688216 13.2654261,5.94067636 L10.120762,3.40626719 C9.91759654,3.24249277 9.61126379,3.19307807 9.34489515,3.2813186 C9.07852651,3.36941795 8.9047619,3.57766559 8.9047619,3.80878519 L8.9047619,9.14373695 C8.9047619,9.37457417 9.07852651,9.58310419 9.34489515,9.67106235 C9.61108774,9.75930288 9.91759654,9.70988818 10.120762,9.54611376 Z",
    id: "icVideoHS"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoHs);
export default __webpack_public_path__ + "static/media/icVideoHS.909434295117c3833b9c11455f577234.svg";
export { ForwardRef as ReactComponent };